define('views/modules/template/edit/calendar/animated-session/animated-session-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    'services/layout',
    'services/events/animated-session-events',
    // model
    'models/template/calendar/template-session',
    // views
    'views/modules/template/edit/calendar/template-calendar-item-panel',
    // views content
    'views/modules/template/edit/calendar/animated-session/session-edit-content',
    'views/modules/calendar/favorite/favorite-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    LayoutState,
    AnimationEvents,
    // model
    MTemplateSession,
    // views
    VTemplateCalendarItemPanel,
    // views content
    VTemplateSessionEditContent,
    VFavoriteContent
) {

    var VTemplateSessionPanel = VTemplateCalendarItemPanel.extend({
        header: {
            title: "calendar:Animated Session",
            subtitle: "calendar:Create/Modify your animated session",
        },

        content: {
            details: VTemplateSessionEditContent,
            favorite: VFavoriteContent,
        },

        initialize: function(options) {
            VTemplateSessionPanel.__super__.initialize.call(this, options);
            this.model = new MTemplateSession();
        },

        showFavorite: function() {
            this.showContent('favorite', {
                type: "animated-session",
                model: this.view.details.model
            });
            AnimationEvents.refreshPanel();
        },

        showDetails: function() {
            VTemplateSessionPanel.__super__.showDetails.apply(this, arguments);
            AnimationEvents.refreshPanel();
        },

        onOpen: function(open) {
            if (this.is(this.view.details) && !Viewport.isMobile() && open) {
                // if there's no exercises yet, show the search panel.
                this.view.details.toggleAnimationPanel(true);
            }
        },

        onSuccess: function() {
            this.close();
        },

    });

    return VTemplateSessionPanel;
});

